import LocalStorage from "./local_storage";
import GameUtil from '../utility/game_util';
import EventManager from "./event_manager";

const { ccclass, property } = cc._decorator;

@ccclass
export default class AudioManager extends cc.Component {

    static instance: AudioManager = new AudioManager()

    _musicOpen: string = "music_volume"
    _soundOpen: string = "sound_volume"
    _vibrateOpen: string = "vibrate"

    _musicVolume: string = "music_volume_number_3"
    _soundVolume: string = "sound_volume_number"

    _musicId = -1
    _lastMusicId = -1
    _curMusicIndex = 0
    _isLoadingMusic = false
    soundCtxPool = []
    maxSoundNum = 8
    _index = 0
    _musicUrl : string = "";

    _packageName2FilePaths: Map<string, string[]> = new Map<string, string[]>()

    private _resMap: Map<string, cc.AudioClip> = new Map<string, cc.AudioClip>();

    onLoad() {
        this._musicId = -1
        this._lastMusicId = -1
        this._isLoadingMusic = false
        //初始化音乐和音效的音量
        let musicLocalVo = Number(LocalStorage.getNumber(this._musicVolume, 0.10)); //默认是一半的
        cc.audioEngine.setMusicVolume(musicLocalVo)
        let soundLocalVo = Number(LocalStorage.getNumber(this._soundVolume, 0.5));
        cc.audioEngine.setEffectsVolume(soundLocalVo)
    }

    private getAudio(key: string, success: Function) {
        let audioClip = this._resMap.get(key)
        if (audioClip) {
            success(audioClip)
            return
        }

        let self = this
        GameUtil.loadRes(key, function (err, clip) {
            if (err) {
                cc.warn(err)
                return
            }
            if (clip) {
                self._resMap.set(key, clip)
                let reg = new RegExp('^package/[a-zA-Z0-9_]{1,}/', 'g')
                let m = key.match(reg)
                if(m && m.length > 0){
                    let p = m[0].replace(new RegExp('^package/', 'g'), '').replace('/', '')
                    let list = self._packageName2FilePaths.get(p)
                    if(!list){
                        list = []
                    }
                    list.push(key)
                    self._packageName2FilePaths.set(p, list)
                }

                success(clip)
            }
        });
    }

    playMusicLoop() {
        this.playHallBgMusic()
    }

    playHallBgMusic(resume?: boolean) {
        let url = "sound/bgm/da_ting"
        this.playMusic(url, true)
    }

    playClubBgMusic(){
        let url = "sound/bgm/ju_le_bu_dating"
        this.playMusic(url, true)
    }
    

    playFightMusic(resume?: boolean) {
        let url = "sound/bgm/bg_zhandou1"
        this.playMusic(url, true)
    }

    playFightMusic2(resume?: boolean) {
        let url = "sound/bgm/bg_zhandou2"
        this.playMusic(url, true)
    }

    /**
     * 
     * @param url 
     * @param loop 
     * @param resetSame 是否从头播放相同的音乐
     */
    playMusic(url: string, loop: boolean = true,resetSame : boolean = false) {
        let self = this
        if (!self.isMusicOpen()) {
            self._musicUrl = url
            self.pauseMusic()
            return
        }
        this.getAudio(url, (clip) => {
            if (self._musicUrl == url && !resetSame){
                self.resumeMusic()
            }
            else{
                self._musicUrl = url;
                self._musicId = cc.audioEngine.playMusic(clip, true);
            }
        });
    }        
       


    isMusicOpen() {
        return LocalStorage.getNumber(this._musicOpen, 0) == 0;
    }

    setMusicOpen(isOpen = true) {
        LocalStorage.setNumber(this._musicOpen, isOpen ? 0 : 1)
    }
    setMusicVolume(volume) {
        volume = Math.max(0,volume);
        volume = Math.min(1,volume);           

        cc.audioEngine.setMusicVolume(volume)
        LocalStorage.setNumber(this._musicVolume, volume)
    }
    isSoundOpen() {
        return LocalStorage.getNumber(this._soundOpen, 0) == 0
    }
    isNeedPlaySound()
    {
        return this.isSoundOpen() && cc.audioEngine.getEffectsVolume() > 0;//加上音量大于0的判断。bug:音量为0也有一点点声音
    }
    setSoundOpen(isOpen = true) {
        LocalStorage.setNumber(this._soundOpen, isOpen ? 0 : 1)
        EventManager.instance.dispatch("SetSoundStatus", isOpen)
    }
    setSoundVolume(volume) {
        
        volume = Math.max(0,volume);
        volume = Math.min(1,volume);      
        
        cc.audioEngine.setEffectsVolume(volume)
        LocalStorage.setNumber(this._soundVolume, volume)
    }
    isVibrateOpen() {
        return LocalStorage.getNumber(this._vibrateOpen, 0) == 0
    }

    setVibrateOpen(isOpen = true) {
        LocalStorage.setNumber(this._vibrateOpen, isOpen ? 0 : 1)
    }

    resumeMusic() {
        cc.log("resumeMusic", this._musicId)
        if (this._musicId != -1) {
            let state = cc.audioEngine.getState(this._musicId)
            
            if (state == cc.audioEngine.AudioState.PLAYING){ 
                 
            }
            else if (state == cc.audioEngine.AudioState.PAUSED){
                cc.audioEngine.resumeMusic()
            }
            else{
                this.startMusic()
            }
        }
        else{
            this.startMusic()
        }
    }

    startMusic() {
        this.playMusic(this._musicUrl, true, true)
    }

    pauseMusic() {
        cc.log("暂停音乐")
        cc.audioEngine.pauseMusic()
    }   

    stopMusic() {
        cc.log("停止音乐")
        cc.audioEngine.stopMusic()
    }   
    

    stopAllMusic() {
        cc.audioEngine.stopAll()
    }

    mute() {
        cc.audioEngine.setMusicVolume(0)
        cc.audioEngine.setEffectsVolume(0)
    }

    playSound(url: string, loop: boolean = false, onFinish?: Function, onStart?: Function) {
        
        if (this.isNeedPlaySound()) {
            this.getAudio(url, (clip : cc.AudioClip) => {
                // cc.log("playsound:", url)
                // cc.log("playsound volume:", cc.audioEngine.getEffectsVolume())

                let id = cc.audioEngine.playEffect(clip, loop);    
                onStart && onStart(id)
                if (onFinish) {
                    cc.audioEngine.setFinishCallback(id, onFinish)
                }                            

                //cc.audioEngine.setEffectsVolume(1)
            });
        }
    }

    stopSound(id: number){
        cc.audioEngine.stop(id)
    }
    pauseSound(id: number){
        cc.audioEngine.pause(id)
    }
    pauseAllSound(){
        cc.audioEngine.pauseAll()
    }
    resumeSound(id: number){
        cc.audioEngine.resume(id)
    }
    resumeAllSound(){
        let self = this
        if (self.isSoundOpen()) {
            cc.audioEngine.resumeAll()
            // EventManager.instance.dispatch("SetSoundStatus", true)
        }
    }

    //释放缓存的声音
    release() {
        this.stopAllSound()
    }

    vibrate() {
        if (this.isVibrateOpen()) {
            // WXGameManager.vibrateLong()
        }
    }

    onDestroy() {
        this.unscheduleAllCallbacks()
    }

    stopAllSound() {
        this.soundCtxPool.forEach(soundCtx => {
            // 暂停或停止了
            if (!soundCtx.paused) {
                soundCtx.stop();
            }
        });
    }

    uncachePackageSounds(packageName: string){
        let list = this._packageName2FilePaths.get(packageName)
        if(list && list.length > 0){
            for (let index = 0; index < list.length; index++) {
                const url = list[index];
                let clip = this._resMap.get(url)
                this._resMap.delete(url)
                cc.audioEngine.uncache(clip)
            }
        }
        this._packageName2FilePaths.delete(packageName)
    }

    getCachedSoundsPackageNames(): string[]{
        let packagenNames = []
        this._packageName2FilePaths.forEach((a, key, map)=>{
            packagenNames.push(key)
        })
        return packagenNames
    }

    // // 获取一个音频实例
    // getSoundCtx() {
    //     let soundCtx = null;
    //     for (let i = 0; i++; i < this.soundCtxPool.length) {
    //         soundCtx = this.soundCtxPool[i];
    //         // 暂停或停止了
    //         if (soundCtx.paused) {
    //             return soundCtx;
    //         }
    //     }
    //     if (!soundCtx) {
    //         // 留一个实例用于播放背景音乐
    //         if (this.soundCtxPool.length < this.maxSoundNum - 1) {
    //             soundCtx = wx.createInnerAudioContext();
    //         } else {
    //             soundCtx = this.soundCtxPool[this._index];
    //             this._index++;
    //             if (this._index > this.maxSoundNum) {
    //                 this._index = 0;
    //             }
    //             soundCtx.stop();
    //         }
    //     }
    //     return soundCtx;
    // }


}